<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Induction Form</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">

  <form #f="ngForm" class="form-container" (ngSubmit)="onSubmit(f)">

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Name</mat-label>
      <input
        matInput
        placeholder="Name"
        [(ngModel)]="induction.name"
        name="name"
        type="text"
        #name
        required />
      <mat-error *ngIf="!name.valid">Please enter an induction name.</mat-error>
    </mat-form-field>

    <editor
      placeholder="Course Introduction"
      [(ngModel)]="induction.description"
      name="description"
      [apiKey]="utils.getTinyMceAPIKey()"
      [init]="{
        base_url: '/assets/tinymce',
        plugins: 'link image lists table media charmap',
        menu: {
          format: {
            title: 'Format',
            items: 'bold italic underline strikethrough superscript subscript codeformat | blocks align | forecolor backcolor | removeformat'
          }
        },
        toolbar: 'undo redo | bold italic underline | forecolor backcolor | bullist numlist | link image media | table | hr | removeformat',
        license_key: 'gpl',
        height: 450
      }">
    </editor>
    <mat-error *ngIf="!induction.description">
      Please fill in the Induction.
    </mat-error>

  </form>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="px-3 py-2">
  <button
    (click)="onSubmit(f)"
    mat-raised-button
    [disabled]="!f.valid || inProgress || !induction.description"
    color="primary"
    class="my-2 ml-1 mr-2"
    id="save">
    <mat-icon>save</mat-icon>
    Save
  </button>

  <mat-slide-toggle
    class="my-2 ml-1 mr-2"
    *ngIf="induction.id" [(ngModel)]="induction.induction_enabled"
    matTooltip="This will allow users to see the induction."
    name="induction_enabled">
    Induction is now <b>{{ induction.induction_enabled ? 'enabled' : 'disabled' }}</b>.
  </mat-slide-toggle>

  <mat-slide-toggle
    class="my-2 ml-1 mr-2"
    *ngIf="induction.id && induction.induction_enabled"
    [(ngModel)]="induction.reset_status"
    matTooltip="This will reset the induction status for all your staff, {{ utils.getLangTerm('contractors.plural', 'Contractors') }} and their {{ utils.getLangTerm('employees.plural', 'Employees') }} resulting in incomplete induction statuses for this induction. They will need to complete and submit this induction again."
    name="reset-status">
    Reset induction statuses
  </mat-slide-toggle>

  <button
    mat-icon-button
    type="button"
    color="warn"
    [disabled]="!induction.id"
    class="dialog-remove-button m-1 ml-auto"
    (click)="onRemove()">
    <mat-icon>delete</mat-icon>
  </button>
</mat-dialog-actions>
